import * as graphql from 'generated/graphql';
import styled from 'styled-components';
import AnswerLine from './AnswerLine';

const IrrelevantAnswerText = styled.p<{ side: 'left' | 'right' }>`
	text-align: ${(props) => (props.side === 'left' ? 'left' : 'right')};
	padding: 8px 0;
	color: ${({ theme }) => theme.colors.slateBlue};
`;

export default function IrrelevantAnswer({ participant }: { participant: graphql.Participant }) {
	const firstName = participant.user.firstName;
	const lastName = participant.user.lastName;

	const side = participant.role === graphql.ConversationRole.Requester ? 'left' : 'right';

	return (
		<AnswerLine user={participant.user} side={side}>
			<IrrelevantAnswerText side={side}>
				<strong>
					{firstName} {lastName}
				</strong>{' '}
				hoeft niets in te vullen.
			</IrrelevantAnswerText>
		</AnswerLine>
	);
}
